import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_WHS_REQUEST = 'GET_WHS_REQUEST';
export const GET_WHS_SUCCESS = 'GET_WHS_SUCCESS';
export const GET_WHS_FAILURE = 'GET_WHS_FAILURE';
export const NEW_WHS_GRID_CRITERIA = 'NEW_WHS_GRID_CRITERIA';

export function newGridCriteria(gridCriteria) {
  return {
    type: NEW_WHS_GRID_CRITERIA,
    gridCriteria
  };
}

function requestGetWhdStatements() {
  return {
    type: GET_WHS_REQUEST,
    loading: true
  };
}

function receiveGetWhdStatements(data) {
  return {
    type: GET_WHS_SUCCESS,
    loading: false,
    data,
    error: ''
  };
}

function rejectGetWhdStatements(error) {
  return {
    type: GET_WHS_FAILURE,
    loading: false,
    data: [],
    error: ''
  };
}

export function getWhdStatements(
  pageNumber,
  pageSize,
  sortBy,
  sortDirection,
  filters,
  activeTab,
  processDataFunc
) {
  return (dispatch) => {
    dispatch(requestGetWhdStatements());

    const promise = () => ApiService
      .getWithholdingStatements(
        pageNumber,
        pageSize,
        sortBy,
        sortDirection,
        filters,
        activeTab
      )
      .then((response) => {
        const processedData = processDataFunc(response.data);
        dispatch(receiveGetWhdStatements(processedData));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(rejectGetWhdStatements(error.response));
          dispatch(handleException(error, null, true));
        }
      });
    return promise();
  };
}
